import $script from 'scriptjs';

// jQuery plugins
import './globals/jquery';
import './globals/aria.jquery.js';
import 'jquery-trend';
import 'jquery-revealer';

// Responsive Images
import 'intersection-observer'; // eslint-disable-line
import rimg from '@pixelunion/rimg-shopify'; // eslint-disable-line

// Flickity iOS fix
import flickityTouchFix from './helpers/FlickityTouchFix';

import ThemeEditor from './components/ThemeEditor';
import Sections from './utils/Sections';
import HomeSlideshow from './sections/HomeSlideshow';
import HomeVideo from './sections/HomeVideo';
import HomeTestimonials from './sections/HomeTestimonials';
import HomeTwitter from './sections/HomeTwitter';
import HomeMap from './sections/HomeMap';
import ProductRecommendations from './sections/ProductRecommendations';
import Cart from './templates/Cart';
import Home from './templates/Home';
import StaticLookbook from './sections/StaticLookbook';
import Account from './templates/Account';
import StaticBlog from './sections/StaticBlog';
import Search from './templates/Search';
import Password from './templates/Password';
import ShareWidget from './components/ShareWidget';
import Sidebar from './components/Sidebar';
import Product from './components/Product';
import TagList from './components/TagList';
import RTE from './components/RTE';
import StaticHeader from './sections/StaticHeader';
import StaticFooter from './sections/StaticFooter';

export default class Vogue {
  constructor() {
    this.$scripts = $('[data-scripts]');
    this.$html = $('html');

    this._init();
  }

  _init() {
    rimg.init();

    // Components
    this.shareWidget = new ShareWidget();
    this.tagList = new TagList();
    this.sidebar = new Sidebar();
    this.rte = new RTE();

    // Page Templates
    this.home = new Home();
    this.cart = new Cart();
    this.product = new Product(this);
    this.account = new Account();
    this.search = new Search();
    this.password = new Password();

    // Theme Editor interactions
    this.themeEditor = new ThemeEditor(this);

    // Theme Sections
    this.sections = new Sections();
    this.sections.register('home-slideshow', section => new HomeSlideshow(section));
    this.sections.register('home-video', section => new HomeVideo(section));
    this.sections.register('home-testimonials', section => new HomeTestimonials(section));
    this.sections.register('home-twitter', section => new HomeTwitter(section));
    this.sections.register('home-map', section => new HomeMap(section));
    this.sections.register('page-lookbook', section => new StaticLookbook(section));
    this.sections.register('page-blog', section => new StaticBlog(section));
    this.sections.register('home-blog-posts', section => new StaticBlog(section));
    this.sections.register('product-recommendations', section => new ProductRecommendations(section));
    this.sections.register('static-header', section => new StaticHeader(section));
    this.sections.register('static-footer', section => new StaticFooter(section));

    flickityTouchFix();

    if (this.$html.hasClass('ie9')) {
      this._ie9Helpers();
    }
  }

  _ie9Helpers() {
    $script(this.$scripts.data('placeholder-ie9'), () => {
      $('input, textarea').placeholder();
    });
  }
}

new Vogue();
